<script lang="ts">
    import { ServiceConsts } from "$/services/ServiceConsts";
    import { ActiveTopicStore, ActiveTopic } from "$/stores/extension/ActiveTopicStore";
    import { TokenStore } from "$/stores/TokenStore";
    import { clickAction } from "$/utils/clickAction";
    import { Kindle } from "$/utils/Kindle";

    let importingFromKindle: boolean = false;

    async function processKindleSnippets(snippets, activeTopicSnippets) {
        let snippetAlreadyImported = false;

        if (snippets.length === 0) return;

        const snippet = snippets.shift();
        const snippetComments = snippet.comments;
        snippet.comments = []; // remove the comments from the snippet so it can be created

        // check if snippet.content and snippet.urlPath already exist in the $ActiveTopic.snippets
        // if they do, just update the snippet
        if (activeTopicSnippets.length > 0) {
            activeTopicSnippets.forEach((s) => {
                // check urlPath and url since we save url in database with # and urlPath without #
                // remove &nbsp; from content to avoid duplicates with kindle highlights
                // since sometimes kindle adds &nbsp; to the end of the content

                let snippetContentToCompare = snippet.content.replace(
                    /&nbsp;/g,
                    " ",
                );
                let snippetFromDBContentToCompare = s.content.replace(
                    /&nbsp;/g,
                    " ",
                );

                snippetContentToCompare = snippetContentToCompare.trim();
                snippetFromDBContentToCompare =
                    snippetFromDBContentToCompare.trim();

                snippetContentToCompare = snippetContentToCompare.replace(
                    /\s/g,
                    "",
                );
                snippetFromDBContentToCompare =
                    snippetFromDBContentToCompare.replace(/\s/g, "");

                if (
                    snippetFromDBContentToCompare === snippetContentToCompare &&
                    s.urlPath === snippet.url
                )
                    snippetAlreadyImported = true;
            });
        }

        if (!snippetAlreadyImported) {
            let createdSnippet = await ActiveTopicStore.createSnippet(snippet);

            if (snippetComments.length > 0 && createdSnippet)
                await ActiveTopicStore.createComment(
                    snippetComments[0],
                    createdSnippet.id,
                );
        }

        await processKindleSnippets(snippets, activeTopicSnippets);
    }

    const importHighlightsFromKindle = async () => {
        if (importingFromKindle) return;

        importingFromKindle = true;

        const kindleBook = await Kindle.getHighlights();

        if (!kindleBook) return;

        let snippetsFromKindleHighlights = kindleBook.highlights.map(
            (highlight) => {
                let snippet = {
                    id: null,
                    content: highlight.text,
                    highlight: {},
                    comments: [],
                    url:
                        ServiceConsts.KINDLE_APP_URL +
                        kindleBook.urlId +
                        ServiceConsts.KINDLE_APP_LOCATION_URL +
                        highlight.locationValue +
                        "&",
                    createdBy: $TokenStore?.user,
                    createdOn: new Date().getTime(),
                };

                if (highlight.note !== "")
                    snippet.comments.push({
                        id: null,
                        comment: highlight.note,
                        createdBy: $TokenStore?.user,
                        createdOn: new Date().getTime(),
                    });

                return snippet;
            },
        );

        await processKindleSnippets(
            snippetsFromKindleHighlights,
            $ActiveTopic?.snippets,
        );

        // set importingFromKindle to false after 1 second
        // to avoid the text to show up for a split second
        setTimeout(() => {
            importingFromKindle = false;
        }, 1000);
    };
</script>

<div
    class="import-kindle-highlights-wide-button"
    use:clickAction={importHighlightsFromKindle}
>
    {#if !importingFromKindle}
        <svg
            class="import-kindle-highlights-wide-button__icon"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="white"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M10.5 19.5h3m-6.75 2.25h10.5a2.25 2.25 0 002.25-2.25v-15a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 4.5v15a2.25 2.25 0 002.25 2.25z"
            />
        </svg>
        Import Highlights
    {:else}
        <svg
            class="import-kindle-highlights-wide-button__loader"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
            />
        </svg>
        Updating...
    {/if}
</div>

<style>
    .import-kindle-highlights-wide-button {
        @apply reset flex w-auto cursor-pointer flex-row items-center justify-center bg-pink-500 px-4 py-1 text-sm text-white transition-all hover:bg-pink-700 hover:pt-3 !important;
    }

    .import-kindle-highlights-wide-button__icon {
        @apply reset mr-2 h-4 w-4 !important;
    }

    .import-kindle-highlights-wide-button__loader {
        @apply reset -ml-1 mr-3 h-4 w-4 animate-spin text-white !important;
    }
</style>
